// extracted by mini-css-extract-plugin
export default {"logout":"SettingsScreen_logout__s13am","logout-title":"SettingsScreen_logout-title__Z+kRo","logout-button":"SettingsScreen_logout-button__TQYgQ"};